import React from "react";
import { Helmet } from "react-helmet-async";

const ServiceDetail = ({ imgSrc, imgAlt, title, description, imagee, price, gallery }) => {
  return (
    <div>
      <Helmet>
        <title>SAWA | {title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href="/about-sawa" />
      </Helmet>
      <section className="relative h-[80vh] flex flex-col justify-center items-center text-white">
        <img
          src={imgSrc}
          alt="Background"
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        />
        <div className="absolute top-0 left-0 w-full h-full bg-black opacity-60 z-10"></div>
        <div className="relative z-20 text-center px-4 sm:px-6 lg:px-8">
          <h1
            className="text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-semibold mb-4"
            data-aos="fade-up"
            data-aos-duration="2000"
          >
            {title}
          </h1>
        </div>
        <div className="absolute top-0 left-0 w-full h-full z-30"></div>
      </section>

      <div
        className="text-black py-3 px-6 mt-28 lg-custom:px-12 flex flex-col lg-custom:flex-row lg-custom:justify-center lg-custom:items-center text-center lg-custom:text-left"
        data-aos="fade-in"
        data-aos-duration="600"
      >
        <div className="lg-custom:w-1/2 flex justify-center lg-custom:justify-end mb-8 lg-custom:mb-0">
          <img src={imagee} alt={imgAlt} className="w-5/6 h-auto rounded-md" />
        </div>
        <div className="flex flex-col justify-center lg-custom:justify-start w-full lg-custom:w-1/2 lg-custom:pl-20">
          <p className="mb-4 demline text-lg lg-custom:text-2xl font-poppins tracking-wide px-2 lg-custom:px-0">
            {description}
          </p>
          <div className="flex justify-center lg-custom:justify-start">
            <button className="bg-primary text-white font-bold tracking-wide py-6 text-lg lg-custom:text-3xl font-poppins w-full sm:w-auto px-20 lg-custom:px-56 rounded-lg mt-4">
              Book Now
            </button>
          </div>
        </div>
      </div>

      <div className="flex flex-col lg-custom:flex-row justify-center lg-custom:justify-start mt-12 space-y-4 lg-custom:space-y-0 lg-custom:space-x-4 px-6 lg-custom:px-36 mb-16">
        {gallery.map((image, index) => (
          <div
            className="w-full lg-custom:w-1/4 p-2"
            key={index}
            data-aos="fade-left"
            data-aos-duration="500"
            data-aos-delay={100 + index * 100}
          >
            <img
              src={image}
              alt={`Gallery ${index + 1}`}
              className="rounded-md h-80 w-full object-cover"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceDetail;
